import axios from '@axios'
import { exec } from 'child_process'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        changePassword: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('change_password', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
